/* ============================================================
   SUPER CAT WORLD — theme.js
   ============================================================ */
(function(){
  'use strict';
  const money = (cents)=> window.SCW && window.SCW.moneyFormat
    ? window.SCW.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents/100).toFixed(2))
    : '$' + (cents/100).toFixed(2);
  const FREE_SHIP = (window.SCW && window.SCW.freeShipThreshold) || 0; // cents; 0 = disabled

  const $ = (s,c)=> (c||document).querySelector(s);
  const $$ = (s,c)=> Array.from((c||document).querySelectorAll(s));

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='toast';document.body.appendChild(toastEl);}
    toastEl.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>'+msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t=setTimeout(()=>toastEl.classList.remove('show'),2600);
  }

  /* ---------- Drawer ---------- */
  const overlay = $('#drawer-overlay');
  const drawer = $('#cart-drawer');
  function openDrawer(){ if(drawer){drawer.classList.add('open');overlay.classList.add('open');document.body.style.overflow='hidden';} }
  function closeDrawer(){ if(drawer){drawer.classList.remove('open');overlay.classList.remove('open');document.body.style.overflow='';} }
  window.SCW_openDrawer = openDrawer;

  /* ---------- Mobile nav ---------- */
  const mnav = $('#mobile-nav');
  $('#burger') && $('#burger').addEventListener('click',()=>{mnav.classList.add('open');overlay.classList.add('open');});
  $('#mnav-close') && $('#mnav-close').addEventListener('click',()=>{mnav.classList.remove('open');overlay.classList.remove('open');});
  overlay && overlay.addEventListener('click',()=>{closeDrawer();mnav&&mnav.classList.remove('open');});

  /* ---------- Render cart drawer ---------- */
  function renderCart(cart){
    const count = cart.item_count;
    $$('.cart-count').forEach(el=>{el.textContent=count;el.classList.toggle('hidden',count===0);});
    const items = $('#drawer-items');
    const foot = $('#drawer-foot');
    if(!items) return;
    if(count===0){
      items.innerHTML='<div class="drawer__empty"><div class="qblock">?</div><p><strong>Your bag is empty.</strong></p><p>Pick a bed and treat your cat like royalty.</p></div>';
      foot && (foot.style.display='none');
      $('#drawer-ship') && ($('#drawer-ship').style.display='none');
      return;
    }
    foot && (foot.style.display='block');
    let html='';
    cart.items.forEach((it,i)=>{
      html+=`<div class="line" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_150x$1$2') : ''}" alt="${it.product_title}">
        <div class="line__info">
          <div class="line__title">${it.product_title}</div>
          ${it.variant_title && it.variant_title!=='Default Title' ? `<div class="line__meta">${it.variant_title}</div>`:''}
          <div class="qty" data-line="${i+1}">
            <button data-act="dec" aria-label="Decrease">−</button>
            <span>${it.quantity}</span>
            <button data-act="inc" aria-label="Increase">+</button>
          </div>
          <button class="line__remove" data-line="${i+1}">Remove</button>
        </div>
        <div class="line__price">${money(it.final_line_price)}</div>
      </div>`;
    });
    items.innerHTML=html;
    $('#drawer-total') && ($('#drawer-total').textContent=money(cart.total_price));

    // free shipping bar
    const shipEl=$('#drawer-ship');
    if(shipEl && FREE_SHIP>0){
      shipEl.style.display='block';
      const remain=FREE_SHIP-cart.total_price;
      const pct=Math.min(100,(cart.total_price/FREE_SHIP)*100);
      shipEl.querySelector('.ship-bar__fill').style.width=pct+'%';
      shipEl.querySelector('.ship-msg').innerHTML = remain>0
        ? `Add <b>${money(remain)}</b> more for FREE shipping!`
        : `🎉 You unlocked <b>FREE shipping!</b>`;
    } else if(shipEl){ shipEl.style.display='none'; }
  }

  function fetchCart(){ return fetch('/cart.js').then(r=>r.json()); }

  function changeLine(line,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line,quantity:qty})}).then(r=>r.json()).then(renderCart);
  }

  document.addEventListener('click',function(e){
    const openBtn=e.target.closest('[data-cart-open]');
    if(openBtn){e.preventDefault();openDrawer();fetchCart().then(renderCart);}
    const closeBtn=e.target.closest('[data-cart-close]');
    if(closeBtn){e.preventDefault();closeDrawer();}
    const q=e.target.closest('.drawer .qty button');
    if(q){
      const wrap=q.closest('.qty');const line=+wrap.dataset.line;
      const cur=+wrap.querySelector('span').textContent;
      const next=q.dataset.act==='inc'?cur+1:cur-1;
      changeLine(line,Math.max(0,next));
    }
    const rm=e.target.closest('.line__remove');
    if(rm){changeLine(+rm.dataset.line,0);}
  });

  /* ---------- Add to cart (forms) ---------- */
  document.addEventListener('submit',function(e){
    const form=e.target.closest('form[action="/cart/add"], form[action^="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    const btn=form.querySelector('[type="submit"]');
    const data=new FormData(form);
    btn && (btn.setAttribute('aria-busy','true'), btn.classList.add('is-loading'));
    const orig = btn ? btn.innerHTML : '';
    if(btn) btn.innerHTML='<span class="spin"></span>';
    fetch('/cart/add.js',{method:'POST',body:data})
      .then(r=>r.json())
      .then(()=>fetchCart())
      .then(cart=>{renderCart(cart);openDrawer();toast('Added to bag!');})
      .catch(()=>toast('Sorry — that variant is unavailable.'))
      .finally(()=>{if(btn){btn.removeAttribute('aria-busy');btn.classList.remove('is-loading');btn.innerHTML=orig;}});
  });

  /* ---------- Announcement rotation ---------- */
  const track=$('#announce-track');
  if(track && track.children.length>1){
    let i=0;const msgs=Array.from(track.children);
    msgs.forEach((m,idx)=>m.style.display=idx===0?'flex':'none');
    setInterval(()=>{msgs[i].style.display='none';i=(i+1)%msgs.length;msgs[i].style.display='flex';},3500);
  }

  /* ---------- Product page: variants + gallery + qty + sticky bar ---------- */
  function initProduct(){
    const root=$('#product-app');
    if(!root) return;
    let variants=[];
    try{variants=JSON.parse($('#product-variants').textContent);}catch(_){}
    const selected={};
    const options=$$('.variant-group',root);

    function currentVariant(){
      if(!options.length) return variants[0];
      return variants.find(v=>v.options.every((o,idx)=>o===selected[idx]));
    }
    function refresh(){
      const v=currentVariant();
      const idInput=$('#variant-id');
      const priceEl=$('#pdp-price');const wasEl=$('#pdp-was');const saveEl=$('#pdp-save');
      const addBtn=$('#add-btn');const barBtn=$('#bar-add');const barPrice=$('#bar-price');
      // mark sold-out swatches (based on last option group)
      if(v){
        idInput && (idInput.value=v.id);
        priceEl && (priceEl.textContent=money(v.price));
        barPrice && (barPrice.textContent=money(v.price));
        if(wasEl){ if(v.compare_at_price>v.price){wasEl.style.display='inline';wasEl.textContent=money(v.compare_at_price);
          if(saveEl){saveEl.style.display='inline-block';saveEl.textContent='Save '+Math.round((1-v.price/v.compare_at_price)*100)+'%';}}
          else{wasEl.style.display='none';saveEl&&(saveEl.style.display='none');} }
        const avail=v.available;
        [addBtn,barBtn].forEach(b=>{if(b){b.disabled=!avail;b.querySelector('.btn-label')&&(b.querySelector('.btn-label').textContent=avail?(root.dataset.preorder==='true'?'Preorder Now':'Add to Bag'):'Sold Out');}});
      }else{
        [addBtn,barBtn].forEach(b=>{if(b){b.disabled=true;b.querySelector('.btn-label')&&(b.querySelector('.btn-label').textContent='Unavailable');}});
      }
    }
    options.forEach((group,gi)=>{
      const sw=$$('.swatch',group);
      const pre=sw.find(s=>s.classList.contains('selected'))||sw[0];
      if(pre){selected[gi]=pre.dataset.value;}
      sw.forEach(s=>s.addEventListener('click',()=>{
        sw.forEach(x=>x.classList.remove('selected'));
        s.classList.add('selected');selected[gi]=s.dataset.value;refresh();
      }));
    });
    refresh();

    // gallery
    const main=$('#gallery-main-img');
    $$('.gallery__thumbs button').forEach(b=>b.addEventListener('click',()=>{
      $$('.gallery__thumbs button').forEach(x=>x.classList.remove('active'));
      b.classList.add('active');
      if(main) main.src=b.dataset.full;
    }));

    // qty
    const qtyInput=$('#qty-input');
    $$('#qty-wrap button').forEach(b=>b.addEventListener('click',()=>{
      let v=parseInt(qtyInput.value||'1',10);
      v=b.dataset.act==='inc'?v+1:Math.max(1,v-1);
      qtyInput.value=v;$('#qty-display')&&($('#qty-display').textContent=v);
    }));

    // sticky bar syncs to main form
    const barAdd=$('#bar-add');
    barAdd && barAdd.addEventListener('click',()=>{ $('#product-form') && $('#product-form').requestSubmit(); });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded',function(){
    fetchCart().then(renderCart).catch(()=>{});
    initProduct();
  });
})();
